import type { EnvConfig } from 'config';
import production from './production';

/** Staging Segment write key — previews must not send analytics to prod Segment. */
const PREVIEW_SEGMENT_KEY = 'VQDMbHw65jkXg4go8KmBnDiXzeAz7GiO';

const cfPreview: EnvConfig = {
  ...production,
  appKeys: {
    ...production.appKeys,
    segment: PREVIEW_SEGMENT_KEY,
  },
  // Previews run on *.surfline.workers.dev, which isn't registered against the
  // production OneTrust script, so the consent banner can't persist a choice or
  // dismiss. Use the -test script (as other non-prod envs do) which allows it.
  oneTrustDomainScript: '89f3dcce-1ffc-42b2-9d52-91fd3af3d675-test',
  robots: 'noindex,nofollow',
  signInUrl: '/preview-sign-in',
  skipTrackingScripts: false,
};

export default cfPreview;
